
import { createSlice } from "@reduxjs/toolkit";

const user_acct = 'john doe';

const initialState =  {
    notifyText: "Notifications",
    msgs: {
        all: [
                {
                    id: 1,
                    heading: 'Login attempted from n...',
                    txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 2,
                    heading: `You've received a new...`,
                    txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 3,
                    heading: `You've received a new...`,
                    txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 4,
                    heading: `You've received a new...`,
                    txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 5,
                    heading: 'Login attempted from n...',
                    txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 6,
                    heading: `You've received a new...`,
                    txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                    date: '2023-02-02',
                    time: '07:31:05'
                },
                {
                    id: 7,
                    heading: 'Login attempted from n...',
                    txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                    date: '2023-02-02',
                    time: '07:31:05'
                },
            ],

        activities: [
            {
                id: 1,
                heading: `You've received a new...`,
                txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 2,
                heading: `You've received a new...`,
                txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 3,
                heading: `You've received a new...`,
                txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 4,
                heading: `You've received a new...`,
                txt: 'Check your task center and complete your tasks to get a reward! Complete task...',
                date: '2023-02-02',
                time: '07:31:05'
            },
        ],

        devices: [
            {
                id: 1,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 2,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 3,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 4,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 5,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 6,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            {
                id: 7,
                heading: 'Login attempted from n...',
                txt: `The system has detected that your account is logged in from an unused IP address. Account: ${user_acct}...`,
                date: '2023-02-02',
                time: '07:31:05'
            },
            
        ]
    }
};


export const notificationSlice = createSlice({
    name: 'notification_/slice',
    initialState,
    reducers: {
        delMessage: (state, action  )=>{
            // alert('deleted mesage');
            state.msgs.all = state.msgs.all.filter( (val)=> val.id !== action.payload.id);
        },

        delActivityNotification: (state, action)=>{
            state.msgs.activities = state.msgs.activities.filter( ( val )=> val.id !== action.payload.id);
        },

        delDevicesNotification: (state, action)=>{
            state.msgs.devices = state.msgs.devices.filter( ( val )=> val.id !== action.payload.id);
        }
    }
});

export const { delMessage, delActivityNotification, delDevicesNotification } = notificationSlice.actions;
export default notificationSlice.reducer;

